import axios from "axios";
import Cookies from "universal-cookie";
import React, { useEffect } from "react";
import { useState } from "react";
import ReactModal from "react-modal";
import { sedesPorInstitucionId } from "../../Services/Rest";

function CreaEncuesta(props) {
  const cookies = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerTipoEncuestas",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: sedesPorInstitucionId + props.institucion,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [postFecha, setPostFecha] = useState([]);
  const [postTipoPaciente, setPostTipoPaciente] = useState([]);
  const [postTipoTrabajador, setPostTipoTrabajador] = useState([]);
  const [postTiempo, setPostTiempo] = useState([]);
  const [postServicio, setPostServicio] = useState([]);
  const [postSede, setPostSede] = useState([]);
  const [postEncuesta, setPostEncuesta] = useState([]);
  const [postTipoContrato, setPostTipoContrato] = useState([]);
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaEncuestas",
      data: {
        institucionId: props.institucion,
        solicitudId: props.idSolicitud,
        usuarioId: cookies.get("id"),
        fecha: postFecha,
        tipoTrabajador: postTipoTrabajador + "",
        servicio: postServicio + "",
        tipoPaciente: postTipoPaciente + "",
        tiempoInstitucion: postTiempo + "",
        estado: "1",
        idTipoEncuesta: postEncuesta,
        sedeId: postSede,
        tipoContrato: postTipoContrato + "",
      },
    })
      .then((Response) => {
        console.log(Response.data);
        window.location.href =
          "/#/PresentaEncuesta/" +
          postEncuesta +
          "/" +
          Response.data +
          "/" +
          props.idSolicitud;
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear" + error);
      });
  };
  const postResultados = (e) => {
    e.preventDefault();

    if (!postEncuesta || postEncuesta == "") {
      alert("Debe seleccionar el tipo de encuesta para ver los resultados");
      return;
    }

    window.location.href =
      "/#/InfoEncuestas/" + postEncuesta + "/" + props.idSolicitud;
  };

  const EncuestaPorTipo = (e) => {
    e.preventDefault();

    if (!postEncuesta || postEncuesta == "") {
      alert("Debe seleccionar el tipo de encuesta para ver los resultados");
      return;
    }

    window.location.href =
      "/#/EncuestaPorTipo/" + postEncuesta + "/" + props.idSolicitud;
  };

  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Instrumentos Evaluativos
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="container">
            <div className="text-left">
              <div class="container-fluid">
                <div class="card shadow mb-4">
                  <div class="card-body">
                    <div class="table-responsive">
                      <form className="user">
                        <div class="card-header py-6">
                          <h6 class="m-0 font-weight-bold text-primary">
                            INSTRUMENTOS EVALUATIVOS
                          </h6>
                        </div>
                        <hr />
                        <div className="form-group row">
                          <div className="col-sm-6">
                            <select
                              className="btn btn-secondary btn-user btn-block"
                              onChange={(e) => setPostEncuesta(e.target.value)}
                            >
                              <option value="">
                                Seleccione tipo de encuesta
                              </option>
                              {list.map((item) => (
                                <option value={item.id}>{item.nombre}</option>
                              ))}
                            </select>
                          </div>

                          <div className="col-sm-6">
                            <select
                              className="btn btn-secondary btn-user btn-block"
                              onChange={(e) => setPostSede(e.target.value)}
                            >
                              <option value="">Seleccione la sede</option>
                              <option value={props.institucion}>
                                No tiene
                              </option>
                              {list1.map((item) => (
                                <option value={item.id}>{item.nombre}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {postEncuesta == 2 ? (
                          <di>
                            <div className="form-group row">
                              <div className="col-sm-12">
                                <div>fecha</div>
                                <input
                                  type="date"
                                  className="form-control form-control-user"
                                  placeholder=""
                                  onChange={(e) => setPostFecha(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-sm-6">
                                <select
                                  className="btn btn-secondary btn-user btn-block"
                                  onChange={(e) =>
                                    setPostTipoTrabajador(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione tipo de trabajador
                                  </option>
                                  <option value="Trabajador asistencial">
                                    Trabajador asistencial{" "}
                                  </option>
                                  <option value="Trabajador administrativo">
                                    Trabajador administrativo{" "}
                                  </option>
                                </select>
                              </div>

                              <div className="col-sm-6">
                                <select
                                  className="btn btn-secondary btn-user btn-block"
                                  onChange={(e) =>
                                    setPostTipoContrato(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione tipo de contrato
                                  </option>

                                  <option value="Planta">Planta </option>
                                  <option value="Otra forma de contratación">
                                    Otra forma de contratación
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div className="form-group row">
                              <div className="col-sm-6">
                                <input
                                  type="text"
                                  className="form-control form-control-user"
                                  placeholder="Tiempo en la institucion"
                                  onChange={(e) =>
                                    setPostTiempo(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </di>
                        ) : postEncuesta == 1 ? (
                          <d1>
                            <div className="form-group row">
                              <div className="col-sm-12">
                                <div>Fecha</div>
                                <input
                                  type="date"
                                  className="form-control form-control-user"
                                  placeholder=""
                                  onChange={(e) => setPostFecha(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-sm-6">
                                <select
                                  className="btn btn-secondary btn-user btn-block"
                                  onChange={(e) =>
                                    setPostTipoPaciente(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione tipo de Usuario
                                  </option>
                                  <option value="Paciente">Paciente</option>
                                  <option value="Acompañante">
                                    Acompañante
                                  </option>
                                </select>
                              </div>
                              <div className="col-sm-6">
                                <select
                                  className="btn btn-secondary btn-user btn-block"
                                  onChange={(e) =>
                                    setPostServicio(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione tipo de Servicio
                                  </option>
                                  <option value="Cirugía">Cirugía</option>
                                  <option value="Consulta externa">
                                    Consulta externa
                                  </option>
                                  <option value="Hospitalización Adultos">
                                    Hospitalización Adultos
                                  </option>
                                  <option value="Hospitalización Pediatría">
                                    Hospitalización Pediatría
                                  </option>
                                  <option value="Hospitalización Obstetricia">
                                    Hospitalización Obstetricia
                                  </option>
                                  <option value="Imágenes Diagnósticas y Terapéuticas">
                                    Imágenes Diagnósticas y Terapéuticas
                                  </option>
                                  <option value="Laboratorio Clínico y Banco de Sangre">
                                    Laboratorio Clínico y Banco de Sangre
                                  </option>
                                  <option value="Odontología">
                                    Odontología
                                  </option>
                                  <option value="Rehabilitación">
                                    Rehabilitación
                                  </option>
                                  <option value="UCI Adultos">
                                    UCI Adultos
                                  </option>
                                  <option value="UCI Neonatal">
                                    UCI Neonatal
                                  </option>
                                  <option value="UCI Pediátrica">
                                    UCI Pediátrica
                                  </option>
                                  <option value="UCI Obstétrica">
                                    UCI Obstétrica
                                  </option>
                                  <option value="UCIInt Adultos">
                                    UCIInt Adultos
                                  </option>
                                  <option value="UCIInt Neonatal">
                                    UCIInt Neonatal
                                  </option>
                                  <option value="UCIInt Pediátrica">
                                    UCIInt Pediátrica
                                  </option>
                                  <option value="Unidad de Cuidados Básicos Neonatal">
                                    Unidad de Cuidados Básicos Neonatal
                                  </option>
                                  <option value="Urgencias Adultos">
                                    Urgencias Adultos
                                  </option>
                                  <option value="Urgencias Pediatría">
                                    Urgencias Pediatría
                                  </option>
                                  <option value="Urgencias Obstetricia">
                                    Urgencias Obstetricia
                                  </option>
                                </select>
                              </div>
                            </div>
                          </d1>
                        ) : (
                          <d1>
                            <div className="form-group row">
                              <div className="col-sm-12">
                                <div>Fecha</div>
                                <input
                                  type="date"
                                  className="form-control form-control-user"
                                  placeholder=""
                                  onChange={(e) => setPostFecha(e.target.value)}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-sm-6">
                                <select
                                  className="btn btn-secondary btn-user btn-block"
                                  onChange={(e) =>
                                    setPostTipoPaciente(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione tipo de Usuario
                                  </option>
                                  <option value="Paciente">Paciente</option>
                                  <option value="Acompañante">
                                    Acompañante
                                  </option>
                                </select>
                              </div>
                              <div className="col-sm-6">
                                <select
                                  className="btn btn-secondary btn-user btn-block"
                                  onChange={(e) =>
                                    setPostServicio(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione tipo de Servicio
                                  </option>
                                  <option value="Cirugía">Cirugía</option>
                                  <option value="Consulta externa">
                                    Consulta externa
                                  </option>
                                  <option value="Hospitalización Adultos">
                                    Hospitalización Adultos
                                  </option>
                                  <option value="Hospitalización Pediatría">
                                    Hospitalización Pediatría
                                  </option>
                                  <option value="Hospitalización Obstetricia">
                                    Hospitalización Obstetricia
                                  </option>
                                  <option value="Imágenes Diagnósticas y Terapéuticas">
                                    Imágenes Diagnósticas y Terapéuticas
                                  </option>
                                  <option value="Laboratorio Clínico y Banco de Sangre">
                                    Laboratorio Clínico y Banco de Sangre
                                  </option>
                                  <option value="Odontología">
                                    Odontología
                                  </option>
                                  <option value="Rehabilitación">
                                    Rehabilitación
                                  </option>
                                  <option value="UCI Adultos">
                                    UCI Adultos
                                  </option>
                                  <option value="UCI Neonatal">
                                    UCI Neonatal
                                  </option>
                                  <option value="UCI Pediátrica">
                                    UCI Pediátrica
                                  </option>
                                  <option value="UCI Obstétrica">
                                    UCI Obstétrica
                                  </option>
                                  <option value="UCIInt Adultos">
                                    UCIInt Adultos
                                  </option>
                                  <option value="UCIInt Neonatal">
                                    UCIInt Neonatal
                                  </option>
                                  <option value="UCIInt Pediátrica">
                                    UCIInt Pediátrica
                                  </option>
                                  <option value="Unidad de Cuidados Básicos Neonatal">
                                    Unidad de Cuidados Básicos Neonatal
                                  </option>
                                  <option value="Urgencias Adultos">
                                    Urgencias Adultos
                                  </option>
                                  <option value="Urgencias Pediatría">
                                    Urgencias Pediatría
                                  </option>
                                  <option value="Urgencias Obstetricia">
                                    Urgencias Obstetricia
                                  </option>
                                </select>
                              </div>
                            </div>
                          </d1>
                        )}
                        <button
                          className="btn btn-primary btn-user btn-block "
                          onClick={postData}
                        >
                          Iniciar Encuesta
                        </button>

                        <button
                          className="btn btn-warning btn-user btn-block "
                          onClick={postResultados}
                        >
                          Ver Resultados
                        </button>

                        <button
                          className="btn btn-info btn-user btn-block "
                          onClick={EncuestaPorTipo}
                        >
                          Ver todas las encuestas
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaEncuesta;
